"use client";

import type { ButtonHTMLAttributes, ReactNode } from "react";
import { useCoarsePointer } from "@/studio/lib/iconButtonTitle";
import "./studio-chrome-kit.css";

type StudioIconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** 28px icon. `sm` is the same size; kept so older calls still compile. */
  size?: "md" | "sm";
  /** "head": the 36px round header pill (DM chat head look). Use in headers and toolbars. */
  variant?: "default" | "head";
  children?: ReactNode;
};

/**
 * Locked icon control — 28px, 6px radius. Avatars and toggles stay round.
 */
export function StudioIconButton({
  size = "md",
  variant = "default",
  className = "",
  type = "button",
  title,
  children,
  ...rest
}: StudioIconButtonProps) {
  const coarse = useCoarsePointer();
  const base =
    size === "sm" ? "cursor-icon-btn cursor-icon-btn-sm" : "cursor-icon-btn";
  const head = variant === "head" ? " studio-head-circle-btn" : "";
  const cls = `${base} studio-chrome-icon-btn is-icon-only${head}${className ? ` ${className}` : ""}`.trim();
  return (
    <button
      type={type}
      className={cls}
      title={coarse ? undefined : title}
      {...rest}
    >
      {children}
    </button>
  );
}
